import { common } from './_common.js';

export class Framework {
	constructor(){
		this.afterChangePage();
	}
	
	afterChangePage(){
		common.init();
		common.resize();
	}
}